export const mostTweetedDocuments = [
    {
        name: 'Tesla',
        authors: [
            {
                name: 'Diego Romero',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'P',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#0194EB',
        mediaType: 'twitter'
    },
    {
        name: 'Audio',
        authors: [
            {
                name: 'Ebenezer Isaac',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1464278533981-50106e6176b1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'P',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#FFBC45',
        mediaType: 'twitter'
    },
    {
        name: 'Toyota',
        authors: [
            {
                name: 'Diego Romero',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1496857239036-1fb137683000?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'N',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#F65D8B',
        mediaType: 'twitter'
    },
    {
        name: 'Tesla',
        authors: [
            {
                name: 'Diego Romero',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1475724017904-b712052c192a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'U',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#1DD1A1',
        mediaType: 'twitter'
    },
    {
        name: 'Toyota',
        authors: [
            {
                name: 'Diego Romero',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1496857239036-1fb137683000?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'N',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#F65D8B',
        mediaType: 'twitter'
    },
    {
        name: 'Tesla',
        authors: [
            {
                name: 'Diego Romero',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1475724017904-b712052c192a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'U',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#1DD1A1',
        mediaType: 'twitter'
    },
    {
        name: 'Toyota',
        authors: [
            {
                name: 'Diego Romero',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1496857239036-1fb137683000?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'N',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#F65D8B',
        mediaType: 'twitter'
    },
    {
        name: 'Tesla',
        authors: [
            {
                name: 'Diego Romero',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1475724017904-b712052c192a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'U',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#1DD1A1',
        mediaType: 'twitter'
    },
    {
        name: 'Tesla',
        authors: [
            {
                name: 'Diego Romero',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'P',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#0194EB',
        mediaType: 'twitter'
    },
    {
        name: 'Audio',
        authors: [
            {
                name: 'Ebenezer Isaac',
                sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
                url: 'http://www.facebook.com/107855142579272',
            },
        ],
        title: 'Tesla (TSLA) stocks soar in week of record highs.',
        matchSentences: [
            'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
        ],
        mediaImageUrl:
            'https://images.unsplash.com/photo-1464278533981-50106e6176b1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
        date: 1498231166838,
        sentiment: 'P',
        reachCount: '1257601',
        sourceName: 'The Washinton Post',
        sourceCountryCode: 'us',
        color: '#FFBC45',
        mediaType: 'twitter'
    },
]

export const topForumns = {
    data: {
      all: [
        {
          key: 'www.dbc.com.ng',
          mention: 240,
          url: ''
        },
        {
          key: 'lotib.com',
          mention: 217,
          url: ''
        },
        {
          key: 'lesvraies.info',
          mention: 160,
          url: ''
        },
        {
          key: 'mangagenki.com',
          mention: 126,
          url: ''
        },
        {
          key: 'www.dionysospress.gr',
          mention: 124,
          url: ''
        },
        {
          key: 'anigameatn-neo.com',
          mention: 107,
          url: ''
        },
        {
          key: 'baseball-matome18.com',
          mention: 106,
          url: ''
        },
        {
          key: 'cloud.iexapis.com',
          mention: 100,
          url: ''
        },
        {
          key: 'zephyrnet.com',
          mention: 86,
          url: ''
        },
        {
          key: 'nigerialoom.com',
          mention: 81,
          url: ''
        },
        {
          key: 'www.onlycy.news',
          mention: 77,
          url: ''
        },
        {
          key: 'beautifuljharkhand.in',
          mention: 71,
          url: ''
        },
      ]
    }
}

export const topSubreddits = {
    data: {
        all: [
            {
              key: 'www.dbc.com.ng',
              mention: 240,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 34
            },
            {
              key: 'lotib.com',
              mention: 217,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 33
            },
            {
              key: 'lesvraies.info',
              mention: 160,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 30
            },
            {
              key: 'mangagenki.com',
              mention: 126,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 29
            },
            {
              key: 'www.dionysospress.gr',
              mention: 124,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 20
            },
            {
              key: 'anigameatn-neo.com',
              mention: 107,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 15
            },
            {
              key: 'baseball-matome18.com',
              mention: 106,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 10
            },
            {
              key: 'cloud.iexapis.com',
              mention: 100,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 1
            },
            {
              key: 'zephyrnet.com',
              mention: 86,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 1
            },
            {
              key: 'nigerialoom.com',
              mention: 81,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 1
            },
            {
              key: 'www.onlycy.news',
              mention: 77,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 1
            },
            {
              key: 'beautifuljharkhand.in',
              mention: 71,
              url: '',
              imageUrl: 'https://assets.meltwater.io/mpkg/flux-icons/latest/dist/mediatypes/png/reddit_color_round@2x.png',
              subscriber: 1
            },
          ]
    }
}